import { render, staticRenderFns } from "./Movimento.vue?vue&type=template&id=77b2f840"
import script from "./Movimento.vue?vue&type=script&lang=js"
export * from "./Movimento.vue?vue&type=script&lang=js"
import style0 from "./Movimento.vue?vue&type=style&index=0&id=77b2f840&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports